import type { FaireProductEntity } from "../../entity_types/product";

export const p_65q3bmxcp5: FaireProductEntity = {
  token: "p_65q3bmxcp5",
  type: "product",
  name: "Cannizzaro Marinara Sauce - 16oz Jar",
  brandToken: "b_yhwcgsa83p",
  brandName: "Cannizzaro Sauces",
  imageUrl:
    "https://cdn.faire.com/fastly/79c325fb5fee8714b8de25d70237839591f584021387ea5d8d64a29e2031318c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d8f47efe89e5a1679e30c621601481e899a418775419cc6c87f6e14b2baa1e15.jpeg",
    "https://cdn.faire.com/fastly/fa52712235c820ea871dcfa07a4456728e945a368852ebe92c54407d72972c8a.jpeg",
    "https://cdn.faire.com/fastly/024b1c8929f2f9e44666158c526a54f96e8a0382e180143520ae4811dc4a657d.png",
    "https://cdn.faire.com/fastly/66a15adcc465ed14f1df9d945a2d201ff28e36442ebfc900515cd34f01947309.jpeg",
    "https://cdn.faire.com/fastly/a94910ac60da7915da1a3a2974d5e8bb6c17c92ca429439180cc2e51fd5517af.jpeg",
    "https://cdn.faire.com/fastly/fbba0e59367557821a2ea5ead9bdb0bf874e5d99d548eb2311e6f76bc4272604.jpeg",
  ],
  priceDollars: 5.25,
  description:
    "Our Marinara Sauce is made and bottled by hand with lots of love! Made from Fresh Tomatoes, Herbs and Vegetables, Local whenever available, is naturally gluten free and has no sugar added. Great on pastas, in lasagna, or just with bread for dipping! See our recipes for more great ideas!\n\nIngredients – Fresh Ripe Tomatoes, Crushed Ripe Tomatoes, Fresh Chopped Onions, White Wine, Parmesan Reggiano, Extra Virgin Olive Oil, Tomato Paste, Shredded Fresh Carrots, Fresh Basil, Fresh Oregano, Fresh Garlic, Sea Salt, Fresh Squeezed Lemon Juice.",
  tags: [],
  msrpDollars: 10.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:22.361Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
